const PUBLICATIONS_PRINT_ENABLED = 'portailB2B_NI-Publications-showPublicationsPrint';
const PRISMIC_ALERTS_ENABLED = 'portailB2B_NI-Prismic-showAlerts';
const MEETINGS_CALENDAR_FILTERS_ENABLED = 'portailB2B_NI-MeetingsCalendar-showFilters';

export { PUBLICATIONS_PRINT_ENABLED, PRISMIC_ALERTS_ENABLED, MEETINGS_CALENDAR_FILTERS_ENABLED };
